// extracted by mini-css-extract-plugin
export default {"imageContainer":"zoomableImage_imageContainer__H8LNZ","img":"zoomableImage_img__VjaEX","zoomedImage":"zoomableImage_zoomedImage__2zpEx"};